import {initialPartnersState, IPartnersState} from "../../state/partners/partners.state";
import {EPartnerActions, PartnerActions} from "../../actions/partners/partners.actions";

export const partnersReducers = (
  state = initialPartnersState,
  action: PartnerActions
):IPartnersState =>{
  switch (action.type) {
    case EPartnerActions.GetPartners: {
      return {
        ...state
      };
    }
    case EPartnerActions.GetPartnersSuccess: {
      return {
        ...state,
        data: action.payload,
        isLoaded: true
      };
    }
    case EPartnerActions.GetPartnersFailure: {
      return {
        ...state,
        data: [],
        isLoaded: false
      };
    }

    case EPartnerActions.GetPartnerDebtAmountSuccess: {
      return {
        ...state,
        data: action.payload,
        isLoaded: true
      };
    }


    case EPartnerActions.GetPartnerCreditLimitAmountSuccess: {
      return {
        ...state,
        data: action.payload,
        isLoaded: true
      };
    }

    default:
      return state;
  }
};

